import { CONTINGENT_EDIT_RESTRICTED_STATUSES } from './constants';

// WI 97790. On an Abandoned or Lost policy where no PIG disbursement has been requested, the contingent
// premium stays editable but its Agent Commission and Underwriter Premium do not. The non-contingent
// section is untouched.
//
// Two conditions only, matching the story: status and IsPigApplied. Systems-of-record is not re-tested -
// unlike the WI 95280 PIG lock-down (where IsPigApplied alone implies SOR, because only LawsysPigService
// can set it), this gate reads raw status, so a SOR check would add a condition the ACs do not ask for.
//
// `pig` is PigButtonStateDto from FullApplicationFormDto (WI 94100); `alreadyApplied` mirrors
// Application.IsPigApplied. Once it is true this returns false and WI 95280's lock-down owns the policy.
export const isContingentCommissionLocked = (selectedApplication) =>
    CONTINGENT_EDIT_RESTRICTED_STATUSES.includes(selectedApplication?.policyStatusMachineName)
    && !selectedApplication?.pig?.alreadyApplied;
